module.exports = __webpack_public_path__ + "static/media/luna_logo.168b2f55.svg";